export default "__VITE_ASSET__B5YLmsvs__"